/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AdmissionStatus } from './AdmissionStatus';
import {
    AdmissionStatusFromJSON,
    AdmissionStatusFromJSONTyped,
    AdmissionStatusToJSON,
} from './AdmissionStatus';
import type { AdmissionStatusCode } from './AdmissionStatusCode';
import {
    AdmissionStatusCodeFromJSON,
    AdmissionStatusCodeFromJSONTyped,
    AdmissionStatusCodeToJSON,
} from './AdmissionStatusCode';
import type { Bed } from './Bed';
import {
    BedFromJSON,
    BedFromJSONTyped,
    BedToJSON,
} from './Bed';
import type { FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInner } from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInner';
import {
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerFromJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerFromJSONTyped,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerToJSON,
} from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInner';
import type { LeadAdmissionStatusInfo } from './LeadAdmissionStatusInfo';
import {
    LeadAdmissionStatusInfoFromJSON,
    LeadAdmissionStatusInfoFromJSONTyped,
    LeadAdmissionStatusInfoToJSON,
} from './LeadAdmissionStatusInfo';
import type { ScreenerInsurance } from './ScreenerInsurance';
import {
    ScreenerInsuranceFromJSON,
    ScreenerInsuranceFromJSONTyped,
    ScreenerInsuranceToJSON,
} from './ScreenerInsurance';

/**
 * 
 * @export
 * @interface ScreenerResident
 */
export interface ScreenerResident {
    /**
     * 
     * @type {string}
     * @memberof ScreenerResident
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ScreenerResident
     */
    facility_id: string;
    /**
     * 
     * @type {string}
     * @memberof ScreenerResident
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof ScreenerResident
     */
    last_name: string;
    /**
     * 
     * @type {string}
     * @memberof ScreenerResident
     */
    dob: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScreenerResident
     */
    gender: string;
    /**
     * Legacy display name. Use `admission_status_code`.
     * @type {AdmissionStatus}
     * @memberof ScreenerResident
     * @deprecated
     */
    admission_status: AdmissionStatus;
    /**
     * 
     * @type {AdmissionStatusCode}
     * @memberof ScreenerResident
     */
    admission_status_code?: AdmissionStatusCode;
    /**
     * 
     * @type {LeadAdmissionStatusInfo}
     * @memberof ScreenerResident
     */
    admission_status_info: LeadAdmissionStatusInfo;
    /**
     * 
     * @type {LeadAdmissionStatusInfo}
     * @memberof ScreenerResident
     */
    previous_admission_status_info?: LeadAdmissionStatusInfo;
    /**
     * 
     * @type {string}
     * @memberof ScreenerResident
     */
    source_id: string;
    /**
     * 
     * @type {string}
     * @memberof ScreenerResident
     */
    source_name: string;
    /**
     * 
     * @type {Bed}
     * @memberof ScreenerResident
     */
    bed: Bed;
    /**
     * 
     * @type {string}
     * @memberof ScreenerResident
     */
    source_discharge_date?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScreenerResident
     */
    failed_review_stage_status_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScreenerResident
     */
    original_move_in_date: string;
    /**
     * 
     * @type {string}
     * @memberof ScreenerResident
     */
    connector: ScreenerResidentConnectorEnum;
    /**
     * 
     * @type {Array<ScreenerInsurance>}
     * @memberof ScreenerResident
     */
    insurances?: Array<ScreenerInsurance>;
    /**
     * 
     * @type {Array<FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInner>}
     * @memberof ScreenerResident
     */
    screener_lead_tags?: Array<FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInner>;
}


/**
 * @export
 */
export const ScreenerResidentConnectorEnum = {
    Aida: 'Aida',
    Aidin: 'Aidin',
    Ensocare: 'Ensocare',
    EnsocareVa: 'Ensocare VA',
    EpicCareLink: 'EpicCare Link',
    EpicCareLinkAlbanyMed: 'EpicCare Link Albany Med',
    EpicCareLinkAllinaHealth: 'EpicCare Link Allina Health',
    EpicCareLinkAsante: 'EpicCare Link Asante',
    EpicCareLinkAscension: 'EpicCare Link Ascension',
    EpicCareLinkAscensionWi: 'EpicCare Link Ascension WI',
    EpicCareLinkAspirusHealth: 'EpicCare Link Aspirus Health',
    EpicCareLinkAtriumHealth: 'EpicCare Link Atrium Health',
    EpicCareLinkBaptistHealth: 'EpicCare Link Baptist Health',
    EpicCareLinkBaptistOneCare: 'EpicCare Link Baptist One Care',
    EpicCareLinkBenefisHealthSystem: 'EpicCare Link Benefis Health System',
    EpicCareLinkBaylorScottWhiteHealth: 'EpicCare Link Baylor Scott & White Health',
    EpicCareLinkBonSecoursMercyHealth: 'EpicCare Link Bon Secours Mercy Health',
    EpicCareLinkBostonMedicalCenter: 'EpicCare Link Boston Medical Center',
    EpicCareLinkBronsonHealthcare: 'EpicCare Link Bronson Healthcare',
    EpicCareLinkBryanHealth: 'EpicCare Link Bryan Health',
    EpicCareLinkBsaHospital: 'EpicCare Link BSA Hospital',
    EpicCareLinkCapeCodHealthcare: 'EpicCare Link Cape Cod Healthcare',
    EpicCareLinkCaroMont: 'EpicCare Link CaroMont',
    EpicCareLinkCarolinaEast: 'EpicCare Link Carolina East',
    EpicCareLinkErlanger: 'EpicCare Link Erlanger',
    EpicCareLinkCentraCare: 'EpicCare Link CentraCare',
    EpicCareLinkChristusHealth: 'EpicCare Link CHRISTUS Health',
    EpicCareLinkConeHealth: 'EpicCare Link Cone Health',
    EpicCareLinkCovenantHealthCare: 'EpicCare Link Covenant HealthCare',
    EpicCareLinkDeaconess: 'EpicCare Link Deaconess',
    EpicCareLinkDenverHealth: 'EpicCare Link Denver Health',
    EpicCareLinkDukeHealth: 'EpicCare Link Duke Health',
    EpicCareLinkEcuHealth: 'EpicCare Link ECU Health',
    EpicCareLinkElCaminoHealth: 'EpicCare Link El Camino Health',
    EpicCareLinkEnloeHealth: 'EpicCare Link Enloe Health',
    EpicCareLinkFirstHealth: 'EpicCare Link FirstHealth',
    EpicCareLinkFmolhsCareConnect: 'EpicCare Link FMOLHS CareConnect',
    EpicCareLinkSelectMedical: 'EpicCare Link Select Medical',
    EpicCareLinkParkview: 'EpicCare Link Parkview',
    EpicCareLinkGenesisHealthcareSystem: 'EpicCare Link Genesis Healthcare System',
    EpicCareLinkGuthrie: 'EpicCare Link Guthrie',
    EpicCareLinkHartfordHealthCare: 'EpicCare Link Hartford HealthCare',
    EpicCareLinkHackensackMeridianHealth: 'EpicCare Link Hackensack Meridian Health',
    EpicCareLinkHealthPartners: 'EpicCare Link HealthPartners',
    EpicCareLinkHealtheConnection: 'EpicCare Link HealtheConnection',
    EpicCareLinkHennepinCountyMedicalCenter: 'EpicCare Link Hennepin County Medical Center',
    EpicCareLinkHillcrestHealthCareSystem: 'EpicCare Link Hillcrest HealthCare System',
    EpicCareLinkHospitalSistersHealthSystem: 'EpicCare Link Hospital Sisters Health System',
    EpicCareLinkHurleyMedicalCenter: 'EpicCare Link Hurley Medical Center',
    EpicCareLinkIowaHealthCare: 'EpicCare Link Iowa Health Care',
    EpicCareLinkIntegrisHealth: 'EpicCare Link Integris Health',
    EpicCareLinkJupiterMedicalCenter: 'EpicCare Link Jupiter Medical Center',
    EpicCareLinkKaiserPermanente: 'EpicCare Link Kaiser Permanente',
    EpicCareLinkKingsDaughtersHealthSystem: 'EpicCare Link King\'s Daughters Health System',
    EpicCareLinkLegacyHealthyPlanet: 'EpicCare Link Legacy Healthy Planet',
    EpicCareLinkMHealthFairview: 'EpicCare Link M Health Fairview',
    EpicCareLinkMainLineHealth: 'EpicCare Link Main Line Health',
    EpicCareLinkMayoClinic: 'EpicCare Link Mayo Clinic',
    EpicCareLinkMercy: 'EpicCare Link Mercy',
    EpicCareLinkMethodistHospitals: 'EpicCare Link Methodist Hospitals',
    EpicCareLinkMethodistHealthSystem: 'EpicCare Link Methodist Health System',
    EpicCareLinkMiddlesexHealth: 'EpicCare Link Middlesex Health',
    EpicCareLinkMyMichiganHealth: 'EpicCare Link MyMichigan Health',
    EpicCareLinkNch: 'EpicCare Link NCH',
    EpicCareLinkNortonHealthcare: 'EpicCare Link Norton Healthcare',
    EpicCareLinkNorthMemorialHealth: 'EpicCare Link North Memorial Health',
    EpicCareLinkOchsnerHealthNetwork: 'EpicCare Link Ochsner Health Network',
    EpicCareLinkOhioHealth: 'EpicCare Link OhioHealth',
    EpicCareLinkOklahomaHeartHospital: 'EpicCare Link Oklahoma Heart Hospital',
    EpicCareLinkOsfHealthCare: 'EpicCare Link OSF HealthCare',
    EpicCareLinkOwensboroHealth: 'EpicCare Link Owensboro Health',
    EpicCareLinkPiedmont: 'EpicCare Link Piedmont',
    EpicCareLinkProvidence: 'EpicCare Link Providence',
    EpicCareLinkProvidenceWashington: 'EpicCare Link Providence Washington',
    EpicCareLinkSaintFrancis: 'EpicCare Link Saint Francis',
    EpicCareLinkSalemHealth: 'EpicCare Link Salem Health',
    EpicCareLinkShannonHealth: 'EpicCare Link Shannon Health',
    EpicCareLinkStElizabethHealthcare: 'EpicCare Link St. Elizabeth Healthcare',
    EpicCareLinkStormontVailHealth: 'EpicCare Link Stormont Vail Health',
    EpicCareLinkSsmHealth: 'EpicCare Link SSM Health',
    EpicCareLinkTexasHealth: 'EpicCare Link Texas Health',
    EpicCareLinkTheQueensHealthSystem: 'EpicCare Link The Queen\'s Health System',
    EpicCareLinkThedaCare: 'EpicCare Link ThedaCare',
    EpicCareLinkTriHealth: 'EpicCare Link TriHealth',
    EpicCareLinkTrinityHealth: 'EpicCare Link Trinity Health',
    EpicCareLinkUcHealth: 'EpicCare Link UCHealth',
    EpicCareLinkUncHealth: 'EpicCare Link UNC Health',
    EpicCareLinkUConnHealth: 'EpicCare Link UConn Health',
    EpicCareLinkUnityPointHealth: 'EpicCare Link UnityPoint Health',
    EpicCareLinkUniversityOfCincinnati: 'EpicCare Link University of Cincinnati',
    EpicCareLinkUniversityOfKansas: 'EpicCare Link University of Kansas',
    EpicCareLinkUniversityOfKansasStFrancis: 'EpicCare Link University of Kansas St Francis',
    EpicCareLinkUniversityOfMarylandMedicalSystem: 'EpicCare Link University of Maryland Medical System',
    EpicCareLinkUniversityOfMississippiMedicalCenter: 'EpicCare Link University of Mississippi Medical Center',
    EpicCareLinkUniversityOfRochesterMedicine: 'EpicCare Link University of Rochester Medicine',
    EpicCareLinkUniversityHealth: 'EpicCare Link University Health',
    EpicCareLinkUniversityOfUtah: 'EpicCare Link University of Utah',
    EpicCareLinkUpmcPinnacle: 'EpicCare Link UPMC Pinnacle',
    EpicCareLinkSouthShoreHealth: 'EpicCare Link South Shore Health',
    EpicCareLinkSouthcoast: 'EpicCare Link Southcoast',
    EpicCareLinkStLukes: 'EpicCare Link St. Luke\'s',
    EpicCareLinkPremierHealth: 'EpicCare Link Premier Health',
    EpicCareLinkUtHealthEastTexas: 'EpicCare Link UT Health East Texas',
    EpicCareLinkUtSouthwesternMedicalCenter: 'EpicCare Link UT Southwestern Medical Center',
    EpicCareLinkVitruvianHealth: 'EpicCare Link Vitruvian Health',
    EpicCareLinkWellstar: 'EpicCare Link Wellstar',
    EpicCareLinkKetteringHealth: 'EpicCare Link Kettering Health',
    EpicCareLinkOlmstedMedicalCenter: 'EpicCare Link Olmsted Medical Center',
    EpicCareLinkFranciscanHealth: 'EpicCare Link Franciscan Health',
    EpicCareLinkMohawkValleyHealthSystem: 'EpicCare Link Mohawk Valley Health System',
    EpicCareLinkGeisinger: 'EpicCare Link Geisinger',
    EpicCareLinkJpsHealthNetwork: 'EpicCare Link JPS Health Network',
    EpicCareLinkPortneuf: 'EpicCare Link Portneuf',
    EpicCareLinkCheyenneRegionalMedicalCenter: 'EpicCare Link Cheyenne Regional Medical Center',
    EpicCareLinkUniversityMedicalCenter: 'EpicCare Link University Medical Center',
    EpicCareLinkCapeFearValley: 'EpicCare Link Cape Fear Valley',
    EpicCareLinkLexingtonMedicalCenter: 'EpicCare Link Lexington Medical Center',
    EpicCareLinkMedicalUniversityOfSouthCarolina: 'EpicCare Link Medical University of South Carolina',
    EpicCareLinkEssentiaHealth: 'EpicCare Link Essentia Health',
    EpicCareLinkUwHealth: 'EpicCare Link UW Health',
    EpicCareLinkNorthMississippiHealthServices: 'EpicCare Link North Mississippi Health Services',
    EpicCareLinkOregonHealthScienceUniversity: 'EpicCare Link Oregon Health & Science University',
    EpicCareLinkLcmcHealth: 'EpicCare Link LCMC Health',
    EpicCareLinkRwjBarnabas: 'EpicCare Link RWJ Barnabas',
    EpicCareLinkLovelaceHealthSystem: 'EpicCare Link Lovelace Health System',
    EpicCareLinkRochesterRegionalHealth: 'EpicCare Link Rochester Regional Health',
    EpicCareLinkAtlanticHealth: 'EpicCare Link Atlantic Health',
    EpicCareLinkBalladHealth: 'EpicCare Link Ballad Health',
    EpicCareLinkGreatRiver: 'EpicCare Link Great River',
    EpicCareLinkMountainsideMedicalCenter: 'EpicCare Link Mountainside Medical Center',
    EpicCareLinkUkHealthCare: 'EpicCare Link UK HealthCare',
    EpicCareLinkCghMedicalCenter: 'EpicCare Link CGH Medical Center',
    EpicCareLinkMosaicLifeCare: 'EpicCare Link Mosaic Life Care',
    EpicCareLinkGundersenHealth: 'EpicCare Link Gundersen Health',
    EpicCareLinkCoxHealth: 'EpicCare Link CoxHealth',
    EpicCareLinkSingingRiver: 'EpicCare Link Singing River',
    EpicCareLinkLickingMemorialHealth: 'EpicCare Link Licking Memorial Health',
    EpicCareLinkWakeMed: 'EpicCare Link WakeMed',
    Fax: 'Fax',
    ManualUpload: 'Manual Upload',
    ManualCopy: 'Manual Copy',
    Repisodic: 'Repisodic',
    WellSkyIntake: 'WellSky Intake',
    WellSkyIntakeCarePortQuickCase: 'WellSky Intake CarePort QuickCase',
    WellSkyCarePortReferralIntake: 'WellSky CarePort Referral Intake',
    WellSkyReferralManagement: 'WellSky Referral Management',
    WellSkyReferralManagementWebReferral: 'WellSky Referral Management Web Referral',
    FourNext: 'Four Next',
    Roc: 'Roc'
} as const;
export type ScreenerResidentConnectorEnum = typeof ScreenerResidentConnectorEnum[keyof typeof ScreenerResidentConnectorEnum];


/**
 * Check if a given object implements the ScreenerResident interface.
 */
export function instanceOfScreenerResident(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "facility_id" in value;
    isInstance = isInstance && "first_name" in value;
    isInstance = isInstance && "last_name" in value;
    isInstance = isInstance && "dob" in value;
    isInstance = isInstance && "gender" in value;
    isInstance = isInstance && "admission_status" in value;
    isInstance = isInstance && "admission_status_info" in value;
    isInstance = isInstance && "source_id" in value;
    isInstance = isInstance && "source_name" in value;
    isInstance = isInstance && "bed" in value;
    isInstance = isInstance && "original_move_in_date" in value;
    isInstance = isInstance && "connector" in value;

    return isInstance;
}

export function ScreenerResidentFromJSON(json: any): ScreenerResident {
    return ScreenerResidentFromJSONTyped(json, false);
}

export function ScreenerResidentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScreenerResident {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'facility_id': json['facility_id'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'dob': json['dob'],
        'gender': json['gender'],
        'admission_status': AdmissionStatusFromJSON(json['admission_status']),
        'admission_status_code': !exists(json, 'admission_status_code') ? undefined : AdmissionStatusCodeFromJSON(json['admission_status_code']),
        'admission_status_info': LeadAdmissionStatusInfoFromJSON(json['admission_status_info']),
        'previous_admission_status_info': !exists(json, 'previous_admission_status_info') ? undefined : LeadAdmissionStatusInfoFromJSON(json['previous_admission_status_info']),
        'source_id': json['source_id'],
        'source_name': json['source_name'],
        'bed': BedFromJSON(json['bed']),
        'source_discharge_date': !exists(json, 'source_discharge_date') ? undefined : json['source_discharge_date'],
        'failed_review_stage_status_id': !exists(json, 'failed_review_stage_status_id') ? undefined : json['failed_review_stage_status_id'],
        'original_move_in_date': json['original_move_in_date'],
        'connector': json['connector'],
        'insurances': !exists(json, 'insurances') ? undefined : ((json['insurances'] as Array<any>).map(ScreenerInsuranceFromJSON)),
        'screener_lead_tags': !exists(json, 'screener_lead_tags') ? undefined : ((json['screener_lead_tags'] as Array<any>).map(FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerFromJSON)),
    };
}

export function ScreenerResidentToJSON(value?: ScreenerResident | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'facility_id': value.facility_id,
        'first_name': value.first_name,
        'last_name': value.last_name,
        'dob': value.dob,
        'gender': value.gender,
        'admission_status': AdmissionStatusToJSON(value.admission_status),
        'admission_status_code': AdmissionStatusCodeToJSON(value.admission_status_code),
        'admission_status_info': LeadAdmissionStatusInfoToJSON(value.admission_status_info),
        'previous_admission_status_info': LeadAdmissionStatusInfoToJSON(value.previous_admission_status_info),
        'source_id': value.source_id,
        'source_name': value.source_name,
        'bed': BedToJSON(value.bed),
        'source_discharge_date': value.source_discharge_date,
        'failed_review_stage_status_id': value.failed_review_stage_status_id,
        'original_move_in_date': value.original_move_in_date,
        'connector': value.connector,
        'insurances': value.insurances === undefined ? undefined : ((value.insurances as Array<any>).map(ScreenerInsuranceToJSON)),
        'screener_lead_tags': value.screener_lead_tags === undefined ? undefined : ((value.screener_lead_tags as Array<any>).map(FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerToJSON)),
    };
}
